// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const ChevronLeft = createSvgIcon(
  <React.Fragment><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 1L4 8l7 7" /></React.Fragment>,
  'small'
);
